// import { useEffect } from 'react'
// import { useSelector } from 'react-redux'
// import 'antd/dist/antd.less'
// // import 'antd/dist/antd.variable.min.css'

// import '../styles/style.css'
// import Routes from './Routes'
// import { light, dark } from './theme'

// const App = () => {
//   const theme = useSelector((state) => state.theme.theme)

//   useEffect(() => {
//     if (theme === 'light') {
//       Object.keys(light).forEach((key) => {
//         document.body.style.setProperty(`--${key}`, light[key])
//       })
//     } else {
//       Object.keys(dark).forEach((key) => {
//         document.body.style.setProperty(`--${key}`, dark[key])
//       })
//     }
//   }, [theme])

//   return <Routes />
// }

// export default App

import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { notification } from 'antd'
import 'antd/dist/antd.less'

import '../styles/style.css'
import Routes from './Routes'
import theme from '../theme.json'
import jwt_decode from 'jwt-decode'
import { decrypt } from '../functions/globalFunctions'
import { QueryClientProvider, QueryClient } from 'react-query'

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (localStorage.getItem('token')) {
      let localToken = localStorage.getItem('token')
      let token = jwt_decode(localToken)
      const tokenData = decrypt(token.data)
      dispatch({
        type: 'VENDOR_INFO',
        payload: tokenData,
      })
    }

    Object.keys(theme).forEach((key) => {
      document.body.style.setProperty(`--${key}`, theme[key])
    })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (!navigator.onLine) {
      notification.error({
        message: 'No Internet Connection!',
        duration: 0,
      })
    }
    // eslint-disable-next-line
  }, [navigator.onLine])

  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <Routes />
    </QueryClientProvider>
  )
}

export default App
